import {getTestProps} from '@benchling/js-test-utils';
import {ActionIcon, createStyles} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {
  REDESIGN_HEADER_ICON_CHIP_INSET_PX,
  REDESIGN_HEADER_ICON_CHIP_SIZE_PX,
} from '../../ui/AIStyleConstants';
import {redesignHeaderIconChipStyles} from './RedesignHeaderIconChip';
import {MINIMIZED_HEADER_HEIGHT} from './RedesignMinimizedHeader';

const useStyles = createStyles(() => ({
  // Positioning lives on a wrapper so the chip itself stays identical to the other header controls
  // (and doesn't have to fight ActionIcon's own `position`).
  wrapper: {
    position: 'absolute',
    left: REDESIGN_HEADER_ICON_CHIP_INSET_PX,
    // Centered on the same band as the minimized header's bar, so the glyph stays on the same pixels
    // when the panel expands or collapses.
    top: (MINIMIZED_HEADER_HEIGHT - REDESIGN_HEADER_ICON_CHIP_SIZE_PX) / 2,
    zIndex: 10,
  },
  button: redesignHeaderIconChipStyles,
}));

export interface RedesignSidebarToggleProps {
  onToggle: () => void;
}

/**
 * The wide view's sidebar toggle: a hamburger floating at the top-left of the panel, independent of
 * whether the sidebar is open. Shares its chip with the rest of the redesigned header's controls.
 */
export default function RedesignSidebarToggle({onToggle}: RedesignSidebarToggleProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <div className={classes.wrapper}>
      <ActionIcon
        {...getTestProps({component: 'RedesignSidebarToggle', element: 'root'})}
        aria-label="Toggle sidebar"
        variant="subtle"
        size="md"
        className={classes.button}
        onClick={onToggle}
      >
        <BenchlingIcon icon="hamburger" />
      </ActionIcon>
    </div>
  );
}
